import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  cabinSelectorWrapper: {},

  multiAirlineLogo: {
    width: '24px',
    height: '24px',
    flexShrink: 0,
  },

  layoverDays: {
    fontSize: Theme.typography.size[0],
    color: Theme.palette.primary.light,
  },

  expandedItinerary: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },

  expandedAirportInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& p': { margin: 0 },
    [Theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },

  expandedAirportInfoSmall: {
    display: 'none',
    '& p': { margin: 0 },
    [Theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },

  airportLabelSmall: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    margin: 0,
  },

  expandedDepartIcon: {
    fontSize: '16px',
    color: Theme.palette.gray[600],
    verticalAlign: 'middle',
    marginRight: '2px',
  },

  expandedFlightDuration: {
    display: 'flex',
    alignItems: 'center',
  },

  expandedDurationIcons: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '8px',
  },

  upperVertical: {
    color: Theme.palette.gray[300],
    fontSize: '18px',
  },

  lowerVertical: {
    color: Theme.palette.gray[300],
    fontSize: '18px',
    marginTop: '-8px',
  },

  expandedDuration: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  expandedDurationLabel: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
  },

  overnightLayover: {
    fontSize: Theme.typography.size[0],
  },

  expandedFlightInfo: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    '& p': { margin: 0 },
  },

  expandedLayover: {
    padding: '2px 0',
  },

  expandedSeparator: {
    margin: '2px 0',
  },

  expandedLayoverDuration: {
    display: 'flex',
    alignItems: 'center',
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    padding: '2px 0',
  },
}));

export default useStyles;
